import { Globe2, LoaderCircle, Plus } from "lucide-react"
import type { ReactNode } from "react"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"

export function AddDomainForm({ id, label, value, onValueChange, onSubmit, submitting, error, placeholder, submitLabel = "Adicionar domínio", helper, className }: {
  id?: string
  label?: string
  value: string
  onValueChange: (value: string) => void
  onSubmit: () => void | Promise<void>
  submitting: boolean
  error?: string
  placeholder: string
  submitLabel?: string
  helper?: ReactNode
  className?: string
}) {
  return (
    <div className={className}>
      {label && <Label htmlFor={id} className="text-sm font-semibold">{label}</Label>}
      <div className={label ? "mt-2 flex flex-col gap-2 sm:flex-row" : "flex flex-col gap-2 sm:flex-row"}>
        <div className="relative min-w-0 flex-1">
          <Globe2 className="muted pointer-events-none absolute left-4 top-1/2 size-4 -translate-y-1/2" />
          <Input
            id={id}
            value={value}
            aria-invalid={Boolean(error)}
            onChange={(event) => onValueChange(event.target.value)}
            onKeyDown={(event) => { if (event.key === "Enter") { event.preventDefault(); void onSubmit() } }}
            placeholder={placeholder}
            className="field-bg h-12 rounded-xl border-border px-4 pl-11 text-[13px]"
          />
        </div>
        <Button type="button" className="h-12 shrink-0 rounded-xl px-5 text-[13px] font-semibold" onClick={() => void onSubmit()} disabled={submitting}>
          {submitting ? <LoaderCircle className="mr-2 size-4 animate-spin" /> : <Plus className="mr-2 size-4" />}
          {submitLabel}
        </Button>
      </div>
      {error ? <p className="mt-2 text-xs font-medium text-destructive">{error}</p> : helper ? <p className="mt-2 text-xs text-muted-foreground">{helper}</p> : null}
    </div>
  )
}
